module.exports = __webpack_public_path__ + "static/media/react-corona.2800ade2.PNG";